<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Permissions" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Permissions</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal">
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Dashboard Features</h6>
                      <div class="col-12 mb-2" v-for="(feature,index) in featureList" :key="index">
                        <h5 class="mb-1">{{ feature.name }}</h5>
                        <div class="custom-control custom-switch mb-1" v-for="(item,ItemIndex) in feature.features"
                             :key="ItemIndex">
                          <input v-if="typeof(item.checked) != 'undefined'" :id="index+'_'+ItemIndex" type="checkbox"
                                 class="custom-control-input" v-model="item.checked"/>
                          <label :class="typeof(item.checked) != 'undefined' ? 'custom-control-label':''"
                                 :for="index+'_'+ItemIndex">
                            {{ item.name }}
                          </label>
                          <button 
                            v-if="item.slug === 'store' && item.checked && $store.getters.isPayfacMerchant"
                            type="button"
                            class="btn btn-sm btn-outline-warning ml-2"
                            @click="openStoreModal(item.id)"
                          >
                            Assign Stores
                          </button>
                        </div>
                      </div>
                      <div class="col-12">
                        <Button class="btn btn-primary mr-1" @click="sendCall" :loading="loader">Save Changes</Button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'merchant-staff' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
  <StoreModal
    :show="showStoreModal"
    :preSelectedStoreIds="selectedStoreIds"
    @hide="showStoreModal = false"
    @assign="handleStoreAssignment"
  />
</template>

<script>
import StoreModal from './StoreModal.vue';

export default {
  components: { StoreModal },
  mounted() {
    setTimeout(() => {
      this.featureList = this.$store.getters.getDashboardFeatures
      if (!this.featureList) {
        this.getDashboardFeatureData()
      }
      this.getStaffFeatureData()

    }, 500);


  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Merchant Staff'},
        {name: 'Permissions'},
      ],
      loader: false,
      featureList: [],
      staffFeatures: {},
      showStoreModal: false,
      selectedStoreIds: [],
      storeFeatureId: null,
    }
  },
  methods: {
    openStoreModal(featureId) {
      this.storeFeatureId = featureId;
      this.showStoreModal = true;
    },
    handleStoreAssignment(storeIds) {
      this.selectedStoreIds = storeIds;
      this.showStoreModal = false;
    },
    sendCall() {
      let featureIds = []
      //extracting ids to send with the request
      this.featureList.forEach(eachFeature => {
        eachFeature.features.forEach(v => {
          if (v.checked) {
            featureIds.push(v.id)
          }
        })
      })
      let data = {
        userId: this.$store.getters.getUpdateStaffData.id,
        featureId: JSON.stringify(featureIds)
      }
      
      // Check if store feature is enabled and add storeIds
      const storeFeatureEnabled = this.featureList.some(feature =>
        feature.features.some(item => item.slug === 'store' && item.checked)
      );

      if (storeFeatureEnabled && this.selectedStoreIds.length > 0) {
        console.log(this.selectedStoreIds)
        // Convert string IDs to numbers to match featureId format
        const numericStoreIds = this.selectedStoreIds.map(id => parseInt(id));
        data.storesIds = JSON.stringify(numericStoreIds);
      }
      this.loader = true
      this.makeRequest('post', 'v1/manage-merchant-staff-features', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'merchant-staff'});
          }
        }

      });

    },
    getDashboardFeatureData() {
      this.makeRequest('post', 'v1/get-dashboard-feature-list', {}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.featureList = callResponse.response.data.data
          }
        }

      });
    },
    getStaffFeatureData() {
      let data = {
        userId: this.$store.getters.getUpdateStaffData.id
        // userId: 5
      }
      this.makeRequest('post', 'v1/get-merchant-staff-features', data, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;


          if (code == 200) {
            // Extract storeIds if present
            if (callResponse.response.data.data[0].storesIds) {
              this.selectedStoreIds = callResponse.response.data.data[0].storesIds;
            }
            
            callResponse.response.data.data[0].features.forEach(v => {
              this.staffFeatures[v.feature_id] = true
            })


            this.featureList.forEach(eachFeature => {
              eachFeature.features.forEach(v => {
                if (typeof (this.staffFeatures[v.id]) != 'undefined') {
                  v.checked = true
                } else {
                  v.checked = false
                }


              })

            })
          }
        }

      });
    },
  },
}
</script>

